<template>
  <div>
    <header
      class="h-12 px-4 border-gray-300 border-b-2 top-0 left-0 right-0 z-[100] justify-between items-center flex"
    >
      <router-link :to="decideURL" class="font-bold"
        ><img src="@/assets/logo.png" class="w-32 h-auto"
      /></router-link>

      <button class="md:hidden" v-on:click="toggleMobileMenu">
        <svg
          v-if="!mobileMenuOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <nav
        v-if="mobileMenuOpen"
        class="inset-0 top-12 fixed bg-white flex flex-col z-[99] justify-center md:hidden"
      >
        <!-- <button
          v-on:click="scrollToPredictions"
          data-ms-membership="6188f7f03a942b000480956e"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300"
        >
          Matches
        </button> -->
        <router-link
          to="/why"
          class="bg-white flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-t-2 border-b-2 border-gray-300"
          >How it works
        </router-link>
        <a
          href="/blog"
          class="bg-white flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-b-2 border-gray-300"
          >Blog
        </a>
        <button
          id="loginbutton"
          v-if="!subscriptionType"
          v-on:click="toggleLoginModal"
          class="bg-white flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-b-2 border-gray-300"
        >
          Login
        </button>
        <button
          v-if="!subscriptionType"
          v-on:click="handleSignUp"
          data-ms-membership="6188f7f03a942b000480956e"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-white bg-blue-700 border-blue-700"
        >
          Signup
        </button>
        <template v-else>
          <button
            v-if="subscriptionType == 'inactive'"
            v-on:click="manageMembership"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg bg-white text-blue-700 md:border-l-2 border-b-2 border-gray-300"
          >
            Upgrade Membership
          </button>
          <router-link
            v-if="subscriptionType == 'active'"
            to="/slips"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg bg-white text-blue-700 md:border-l-2 border-b-2 border-gray-300"
            active-class="!bg-blue-700 !text-white"
            >My slips
          </router-link>
          <router-link
            to="/account"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg bg-white text-blue-700 md:border-l-2 border-b-2 border-gray-300"
            active-class="!bg-blue-700 !text-white"
            >My account
          </router-link>
          <button
            v-on:click="handleLogout"
            data-ms-modal="profile"
            class="border-b-2 flex items-center justify-center h-12 px-4 lg:px-8 text-lg bg-white text-blue-700 md:border-l-2 border-gray-300"
          >
            <template v-if="loggingOut">Logging out...</template
            ><template v-else>Log out</template>
          </button>
        </template>
      </nav>
      <nav class="hidden md:flex h-12 divide-x-2 -mr-4">
        <!-- <button
          v-on:click="scrollToPredictions"
          data-ms-membership="6188f7f03a942b000480956e"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300"
        >
          Matches
        </button> -->
        <router-link
          to="/why"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300"
          >How it works
        </router-link>
        <a
          href="/blog"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300"
          >Blog
        </a>
        <button
          id="loginbutton"
          v-if="!subscriptionType"
          v-on:click="toggleLoginModal"
          class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300"
        >
          Login
        </button>
        <button
          v-if="!subscriptionType"
          v-on:click="handleSignUp"
          data-ms-membership="6188f7f03a942b000480956e"
          class="flex items-center border-b justify-center h-12 px-4 lg:px-8 text-lg text-white bg-blue-700 border-l-2 border-gray-300"
        >
          Signup
        </button>
        <template v-else>
          <button
            v-if="subscriptionType == 'inactive'"
            v-on:click="manageMembership"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300 md:border-b-2 md:mt-px"
          >
            Upgrade Membership
          </button>
          <router-link
            v-if="subscriptionType == 'active'"
            to="/slips"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300 md:border-b-2 md:mt-px"
            active-class="!bg-blue-700 !text-white"
            >My slips
          </router-link>
          <router-link
            to="/account"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300 md:border-b-2 md:mt-px"
            active-class="!bg-blue-700 !text-white"
            >My account
          </router-link>
          <button
            v-on:click="handleLogout"
            data-ms-modal="profile"
            class="flex items-center justify-center h-12 px-4 lg:px-8 text-lg text-blue-700 border-l-2 border-gray-300 md:border-b-2 md:mt-px"
          >
            <template v-if="loggingOut">Logging out...</template
            ><template v-else>Log out</template>
          </button>
        </template>
      </nav>
    </header>

    <div
      class="fixed w-screen h-screen bg-black bg-opacity-70 inset-0 z-20 flex items-center justify-center"
      v-if="loginModalOpen"
      v-on:click.self="closeLoginModal"
    >
      <div class="relative bg-white rounded-xl w-full max-w-lg">
        <button
          type="button"
          v-on:click="closeLoginModal"
          aria-label="Close"
          class="absolute right-3 top-3 p-1 text-black"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div class="text-center py-6 bg-gray-200 rounded-t-xl">
          <img src="@/assets/logo.png" class="w-64 inline-block h-auto" />
          <h2 class="mt-4 mb-0">Welcome back</h2>
        </div>
        <form class="space-y-4 text-left p-6">
          <label class="block">
            <span class="block mb-2">email address</span>
            <input
              class="border border-gray-300 p-4 w-full"
              type="email"
              v-model="email"
            />
          </label>

          <label class="block">
            <span class="block mb-2">password</span>
            <input
              class="border border-gray-300 p-4 w-full"
              type="password"
              v-model="password"
            />
          </label>

          <p class="text-sm my-4 text-red-600 text-left" v-if="error">
            {{ error }}
          </p>

          <div class="flex justify-between items-center text-sm text-gray-500">
            <span></span>
            <router-link to="/reset">Reset my password</router-link>
          </div>
          <div class="text-center">
            <span v-if="!submitting">
              <button
                type="submit"
                v-on:click="testLogin"
                class="btn-grey shadow-xl inline-flex items-center justify-center text-xs p-3 px-6 font-semibold uppercase lg:text-lg text-blue-700"
              >
                Login
              </button></span
            >
            <span v-else>
              <button
                class="bg-gray-300 border rounded-lg mx-auto border-gray-300 px-4 py-3 inline-block text-blue-700 relative opacity-50 cursor-not-allowed pointer-events-none"
              >
                Logging in
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./../api";

export default {
  name: "Header",
  data() {
    return {
      mobileMenuOpen: false,
      loginModalOpen: false,
      email: "",
      password: "",
      submitting: false,
      error: false,
      loggingOut: false,
    };
  },
  mounted() {},
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.$emit("toggleMobileMenu", this.mobileMenuOpen);
      if (this.mobileMenuOpen) {
        document.body.classList.add("h-screen");
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("h-screen");
        document.body.classList.remove("overflow-hidden");
      }
    },
    toggleLoginModal() {
      this.loginModalOpen = !this.loginModalOpen;
      this.mobileMenuOpen = false;
      this.$emit("toggleMobileMenu", false);
      document.body.classList.remove("h-screen");
      document.body.classList.remove("overflow-hidden");
      this.loginModalOpen = true;
    },
    // toggleLoginModal only ever opens (other pages call it to show the form)
    closeLoginModal() {
      this.loginModalOpen = false;
    },
    handleSignUp() {
      this.$router.push("/signup/");
    },
    manageMembership() {
      this.$router.push("/signup/");
    },
    scrollToPredictions() {
      this.toggleMobileMenu();
      this.$router.push("/#matches");
      setTimeout(() => {
        window.donotscroll = true;
        this.$router.push("/predictions");
      }, 500);
    },
    testLogin(event) {
      event.preventDefault();
      if (this.email && this.password) {
        this.submitLogIn(event);
      }
    },
    async submitLogIn(event) {
      this.error = false;
      this.submitting = true;
      event.preventDefault();
      let data = {
        email: this.email,
        password: this.password,
      };

      API.post("/user/login", false, data)
        .then((response) => {
          this.$store.commit("storeAccessTokens", response.data);

          let auth = {
            idToken: this.$store.getters.accessTokens.id_token,
          };
          API.get("/user", auth)
            .then((response) => {
              if (response.data.preferences) {
                this.$store.commit(
                  "storePreferences",
                  response.data.preferences
                );
              }
              this.$store.commit(
                "storeSubscriptionType",
                response.data.subscription
              );
              this.$store.commit("storeUserID", response.data.user_id);

              this.$store.commit(
                "storeCustomerID",
                response.data.stripe_customer_id
              );
              this.toggleLoginModal();
              this.toggleMobileMenu();
              window.location = window.location.origin + "/predictions";
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          if (error.response.data) {
            this.submitting = false;
            this.error =
              "Invalid username or password. Please note, email addresses are case sensitive.";
            // this.error = error.response.data.body
            //   ? error.response.data.body
            //   : error.response.data;
          }
        });
    },
    async handleLogout() {
      let auth = {
        idToken: this.$store.getters.accessTokens.id_token,
      };
      let data = {
        accessToken: this.$store.getters.accessTokens.access_token,
      };
      this.loggingOut = true;
      API.post("/user/logout", auth, data)
        .then(() => {
          this.$store.commit("storeAccessTokens", {});
          this.$store.commit("storeUserID", false);
          this.$store.commit("storeCustomerID", false);
          this.$store.commit("storeSubscriptionType", false);
          this.$store.commit("storePreferences", null);
          this.$router.push("/");
          setTimeout(() => {
            location.reload();
          }, 200);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    decideURL() {
      return this.subscriptionType ? "/predictions" : "/";
    },
    subscriptionType() {
      return this.$store.getters.subscriptionType;
    },
    stripeProductCode() {
      return this.$store.getters.stripeProductCode;
    },
  },
};
</script>

<style>
.ms-style .ms-portal-exit.ms-portal-exit {
  display: flex !important;
  padding: 0 !important;
}

.btn-grey {
  background: #d1d5db;
  border: none;
  border-radius: 0.5rem;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.btn-grey:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 25px rgba(0, 0, 0, 0.15),
    0 4px 15px rgba(0, 0, 0, 0.1);
}
</style>
